import { FC } from 'react'
import { Box, ColumnLayout, SpaceBetween } from '@cloudscape-design/components'
import useSingleTags from '../../../hooks/query/useSingleTags'
import LoadingSpinner from '../../LoadingSpinner'
import ApproverOverview from '../ApproverOverview'
import { keysToLabel } from '../../../helper/toCamelCase'
import { getProjectLevelApprovals } from '../../../helper/applicationTagApproval'

interface ReadGenericTagsProps {
	tagsId: string
	layout?: number
	showApprovalStatus?: boolean
}

const ReadGenericTagsGCP: FC<ReadGenericTagsProps> = ({
	tagsId,
	layout = 2,
	showApprovalStatus = true
}) => {
	const { data: originalTags, isLoading: isLoadingTags } = useSingleTags(tagsId)

	if (!originalTags || isLoadingTags) return <LoadingSpinner />

    // "applications" is the per-application registry on a shared GCP Project tag record,
    // not a tag value - it is rendered on each application request instead.
    const excludedKeys = ["tagProject", "dataClassification", "applications"];
    const tagKeys = Object.keys(originalTags['details']).filter(
        (key) => !excludedKeys.includes(key)
    )
	const getLabel = (tagkey: string) => {
		switch (tagkey) {
			case 'tagProject':
				return 'Project'
			case 'WBSCode':
			case 'W B S Code':
				return 'WBS Code'
			default:
				return keysToLabel(tagkey)
		}
	}
	return (
		<>
			<SpaceBetween direction="vertical" size="s">
				<ColumnLayout columns={layout} variant="text-grid">
					{tagKeys?.map((tagkey) => (
						<div key={tagkey}>
							<Box variant="awsui-key-label">{getLabel(tagkey)}</Box>
							{typeof originalTags['details'][tagkey] === 'object'
								? originalTags['details'][tagkey]['value']
								: originalTags['details'][tagkey] === ''
								? 'NA'
								: originalTags['details'][tagkey]}
						</div>
					))}
				</ColumnLayout>
				{showApprovalStatus && (
					// Project level only: per-application approvals belong to their own
					// application request, so the Project Page renders exactly as before.
					<ApproverOverview
						approvalStatus={getProjectLevelApprovals(
							originalTags['approvalStatus']
						)}
						isDisabled={true}
					/>
				)}
			</SpaceBetween>
		</>
	)
}

export default ReadGenericTagsGCP
